// Columnas de tabla estándar. Los ids coinciden con el catálogo del backend (features/facturas/facturas.tabla.js).
// Generado con apis-node/scripts/columnas-front.mjs: si se añade una columna allí, se regenera aquí
// (el backend rechaza ids que no conozca).

export const COLUMNAS_FACTURAS = [
  {
    id: 'factura',
    label: 'Factura',
    width: 100,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Factura',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'General',
  },
  {
    id: 'fecha',
    label: 'Fecha de emisión',
    width: 140,
    sortable: true,
    filter: 'date',
    group: 'Factura',
    hora: true,
  },
  {
    id: 'matricula',
    label: 'Matrícula',
    width: 110,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Factura',
  },
  { id: 'cliente', label: 'Cliente', width: 220, sortable: true, filter: 'text', group: 'Cliente' },
  {
    id: 'CIFCliente',
    label: 'CIF cliente',
    width: 130,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Cliente',
  },
  { id: 'alumno', label: 'Alumno', width: 220, sortable: true, filter: 'text', group: 'Alumno' },
  {
    id: 'NIFAlumno',
    label: 'NIF alumno',
    width: 130,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Alumno',
  },
  {
    id: 'TotalNeto',
    label: 'Total neto',
    width: 110,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Importes',
  },
  {
    id: 'TotalImpuesto',
    label: 'Total impuesto',
    width: 120,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Importes',
  },
  {
    id: 'TotalBruto',
    label: 'Total bruto',
    width: 110,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Importes',
  },
  {
    id: 'descripcion',
    label: 'Descripción',
    width: 240,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Factura',
  },
  {
    id: 'Estadorecibos',
    label: 'Estado de los recibos',
    width: 190,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Factura',
  },
  {
    id: 'EstadoFactura',
    label: 'Estado de la factura',
    width: 160,
    sortable: true,
    filter: 'multi',
    group: 'Factura',
  },
  { id: 'centro', label: 'Centro', width: 190, sortable: true, filter: 'multi', group: 'Factura' },
  {
    id: 'plan',
    label: 'Plan',
    width: 240,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Alumno',
  },
  {
    id: 'grupo',
    label: 'Grupo',
    width: 200,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Alumno',
  },
  {
    id: 'nabono',
    label: 'Número de abono',
    width: 140,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Abono',
  },
  {
    id: 'iabono',
    label: 'Importe de abono',
    width: 130,
    sortable: true,
    filter: 'text',
    align: 'right',
    defaultVisible: false,
    group: 'Abono',
  },
  {
    id: 'fabono',
    label: 'Fecha de abono',
    width: 130,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Abono',
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const TABLA_FACTURAS = 'facturas';
